"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
class ExtensionsUserInfoStore {
    constructor() {
        this.id = null;
        this.email = '';
        this.name = '';
        this.attendant = false;
        this.ucode = '';
        this.extensions = false;
        this.extensionsFreemium = false;
        this.isSurrogate = false;
    }
    set profile(value) {
        if (!value) {
            return;
        }
        Object.assign(this, value);
    }
    get extensionsUserInfo() {
        return {
            id: this.id,
            attendant: this.attendant,
            email: this.email,
            name: this.name,
            profile: {
                ucode: this.ucode,
                extensions: this.extensions,
                extensionsFreemium: this.extensionsFreemium,
                isSurrogate: this.isSurrogate
            }
        };
    }
}
__decorate([
    mobx_1.observable
], ExtensionsUserInfoStore.prototype, "id", void 0);
__decorate([
    mobx_1.observable
], ExtensionsUserInfoStore.prototype, "email", void 0);
__decorate([
    mobx_1.observable
], ExtensionsUserInfoStore.prototype, "name", void 0);
__decorate([
    mobx_1.observable
], ExtensionsUserInfoStore.prototype, "attendant", void 0);
__decorate([
    mobx_1.observable
], ExtensionsUserInfoStore.prototype, "ucode", void 0);
__decorate([
    mobx_1.observable
], ExtensionsUserInfoStore.prototype, "extensions", void 0);
__decorate([
    mobx_1.observable
], ExtensionsUserInfoStore.prototype, "extensionsFreemium", void 0);
__decorate([
    mobx_1.observable
], ExtensionsUserInfoStore.prototype, "isSurrogate", void 0);
__decorate([
    mobx_1.computed
], ExtensionsUserInfoStore.prototype, "extensionsUserInfo", null);
exports.default = new ExtensionsUserInfoStore();
